import React from 'react'
import { Modal, Button } from 'react-bootstrap'

export default function BrandSuggestionModal({
  show,
  onHide,
  suggestions,
  onSelect,
  onKeepNew,
  newBrand,
}) {
  return (
    <Modal show={show} onHide={onHide} backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title>Brand simili trovati</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Esistono già brand molto simili:</p>
        <ul>
          {suggestions.map((brand) => (
            <li key={brand}>
              <Button variant="link" onClick={() => onSelect(brand)}>
                Usa &quot;{brand}&quot;
              </Button>
            </li>
          ))}
        </ul>
        <p>Vuoi usare uno di questi oppure creare comunque &quot;{newBrand}&quot;?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Annulla
        </Button>
        <Button variant="primary" onClick={onKeepNew}>
          Continua con &quot;{newBrand}&quot;
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
